<script setup lang="ts">

import { CDN } from '@/models/cdn.ts'
import ModalTrigger from '@/components/Interface/Modal/ModalTrigger.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
defineProps({
  techId: {
    type: Number,
    required: true
  },
  imageCode: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  }
});

</script>

<template>
  <div class="flex">
    <ModalTrigger type="tech" :data="{'techId': techId}" class="flex-shrink-0">
      <img :src="CDN.technology(128,imageCode)" class="rounded h-20" alt=""/>
    </ModalTrigger>
    <div class="px-2">
      <div class="text-slate-300 pb-0.5">{{ t('research.technologyRequired') }}</div>
      <div class="text-subtext pt-1">{{ text }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>